import Header from 'modules/header/wholesaler/main';

import {Form, Formik} from 'formik';
import AuctionFormComponent from 'components/forms/auction';
import {initialValues, initialValuesCreator} from './utilities/initialValues';
import {schema} from './utilities/validationSchema';
import {formDataCreator} from '../../utilities/formDataCreatot';
import {useWholesaler} from 'context/wholesaler';
import usePostEditAd from '../../hooks/usePostEditAd';
import useSetAnswers from 'pages/farm/createAd/form/owner/simple/hooks/useSetAnswers';
import {useState} from 'react';
import {useParams} from 'react-router-dom';
import useGetPostDetail from 'pages/farm/productDetail/hooks/useGetPostDetail';
import usePostEditDetail from 'pages/farm/createAd/editForm/hooks/usePostEditDetail';

const AuctionForm = () => {
  const {guid} = useParams();
  const {productDetail} = useGetPostDetail(guid || '');
  const {postEditDetail} = usePostEditDetail(guid || '');

  const {wholesaler} = useWholesaler();
  const {isLoading, mutate} = usePostEditAd();
  const {answers, handleAnswers} = useSetAnswers();
  const [isChecked, setIsChecked] = useState<boolean>(false);
  return (
    <>
      <Header title="ثبت آگهی فروش محصول " />
      <div className="mt-8">
        <p className=" text-gray-6 font-extrabold my-3">تعیین قیمت</p>
      </div>
      <Formik
        enableReinitialize
        initialValues={
          productDetail
            ? initialValuesCreator(productDetail, postEditDetail)
            : initialValues
        }
        validationSchema={schema}
        onSubmit={values => {
          const payload = new FormData();
          formDataCreator(payload, wholesaler, guid);
          payload.append('price', values?.price);
          payload.append('duration', values?.duration);
          payload.append('duration_unit', values?.duration_unit);
          if (answers.length > 0 && isChecked) {
            const answersGuid: string[] = [];
            answers.map(item => answersGuid.push(item?.guid));
            payload.append('answers', answersGuid?.toString());
          }
          !isLoading && mutate(payload);
        }}
      >
        {({values}) => (
          <Form className="px-3">
            <AuctionFormComponent
              values={values}
              isLoading={isLoading}
              subProduct={wholesaler?.subProduct}
              handleAnswers={handleAnswers}
              answers={answers}
              isChecked={isChecked}
              setIsChecked={setIsChecked}
            />
          </Form>
        )}
      </Formik>
    </>
  );
};

export default AuctionForm;
